import styled, {css, keyframes} from "styled-components";

const thinkingPulse = keyframes`
    0%, 100% {
        opacity: 0.3;
    }
    50% {
        opacity: 1;
    }
`;

interface ThinkingWrapperProps {
    $isGenerating: boolean;
}

export const ThinkingWrapper = styled.div<ThinkingWrapperProps>`
    color: ${({ theme }) => theme.palette.message.thinking};
    
    ${({ $isGenerating }) =>
    $isGenerating
        ? css`animation: ${thinkingPulse} 1s ease-in-out infinite;`
        : css`animation: none;`}
`;

export const ThinkingText = styled.p<{ $expanded: boolean }>`
    margin: 0;
    overflow: hidden;
    
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: ${({ $expanded }) => ($expanded ? 'unset' : 2)};
`;